export default "__VITE_ASSET__WzJ3i_ZP__"